import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Context } from '..';

import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { MailingCreator, MailingHistory, MailingAutoCreator } from '../components/Mailing';
import AutoTriggersPage from "../features/triggers/AutoTriggesPage";

const MailingPage = () => {
  const { user } = useContext(Context);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabValues = useMemo(() => new Set(['1', '2', '3']), []);
  const tabFromQuery = searchParams.get('tab');
  const initialValue = tabValues.has(tabFromQuery) ? tabFromQuery : '1';
  const [value, setValue] = useState(initialValue);

  const tabs = [
    { label: 'Рассылка', value: '1', component: <MailingCreator /> },
    {
      label: 'Рассылка по событиям',
      value: '2',
      component: <AutoTriggersPage />,
    },
    { label: 'История', value: '3', component: <MailingHistory /> },
  ];

  const handleChange = (event, newValue) => {
    if (!tabValues.has(newValue)) {
      return;
    }
    setValue(newValue);
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('tab', newValue);
      return next;
    }, { replace: true });
  };

  useEffect(() => {
    if (!tabValues.has(tabFromQuery)) {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set('tab', '1');
        return next;
      }, { replace: true });
    }
  }, [setSearchParams, tabFromQuery, tabValues]);

  useEffect(() => {
    const currentTab = searchParams.get('tab');
    if (tabValues.has(currentTab) && currentTab !== value) {
      setValue(currentTab);
    }
  }, [searchParams, tabValues, value]);

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            aria-label='Settings tabs'
            onChange={handleChange}
            textColor='secondary'
            indicatorColor='secondary'
            variant='scrollable'
            scrollButtons={false}
          >
            {tabs
              .map((tab) => {
                return <Tab key={tab.value} label={tab.label} value={tab.value} />;
              })
              .filter((tab) => tab !== null)}
          </TabList>
        </Box>
        {tabs.map((tab) => (
          <TabPanel key={tab.value} value={tab.value}>
            {tab.component}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

export default MailingPage;
